/* eslint-disable */
export default {
  createCallLog: '通話ログの作成',
  viewInSalesforce: 'Salesforceで表示',
  createLog: 'ログを作成',
} as const;

// @key: @#@"createCallLog"@#@ @source: @#@"Create call log"@#@
// @key: @#@"viewInSalesforce"@#@ @source: @#@"View in Salesforce"@#@
// @key: @#@"createLog"@#@ @source: @#@"Create log"@#@
